import React from 'react';
import { useTranslation } from 'react-i18next';

interface FireStationContentProps {
  fireStation?: any;
}

const FireStationContent: React.FC<FireStationContentProps> = ({ fireStation }) => {
  const { t } = useTranslation();

  if (!fireStation) {
    return (
      <div style={{ marginBottom: '16px', color: '#666', fontStyle: 'italic', textAlign: 'center', padding: '20px' }}>
        {t("fireStation.empty")}
      </div>
    );
  }

  const properties = fireStation.properties || {};
  const distance = properties.distance?.calculated;

  return (
    <>
      {properties.name && (
        <div style={{ marginBottom: '16px' }}>
          <strong style={{ color: '#333' }}>{t("fireStation.name")} :</strong> {properties.name}
        </div>
      )}

      {properties.operator && (
        <div style={{ marginBottom: '16px' }}>
          <strong style={{ color: '#333' }}>{t("fireStation.operator")} :</strong> {properties.operator}
        </div>
      )}

      {distance != null && (
        <div style={{ marginBottom: '16px' }}>
          <strong style={{ color: '#333' }}>{t("fireStation.distance")} :</strong> {Math.floor(distance)} m
        </div>
      )}

      <div style={{ marginBottom: '16px' }}>
        <strong style={{ color: '#333' }}>{t("fireStation.type")} :</strong>{' '}
        {properties.fire_station_type_FR || t("fireStation.notProvided")}
      </div>
    </>
  );
};

export default FireStationContent;
